import { __makeTemplateObject } from 'tslib';
import styled from 'styled-components';
import { backgroundColor, typography, space, grids, layout, borders, opacity, overflow, positioning, boxShadow } from '../../../node_modules/@xstyled/system/dist/xstyled-system.es.js';
import { shouldForwardProp } from '../../should-forward-prop.js';
import { flexboxes } from '../../system.js';

var Box = /*#__PURE__*/styled("div").withConfig({
  shouldForwardProp: function (prop, defaultValidtorFn) {
    return shouldForwardProp(prop) && defaultValidtorFn(prop);
  },
  displayName: "Box",
  componentId: "sc-8xxshb-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  margin: 0;\n  padding: 0;\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), backgroundColor, flexboxes, typography, space, grids, layout, borders, opacity, overflow, positioning, boxShadow);
var templateObject_1;

export { Box };
//# sourceMappingURL=Box.js.map
